module.exports = __webpack_public_path__ + "static/card-sponsorships-2-600f78b0558c97b45ce9ed26c2885ed6.jpg";